(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("redux-actions"), require("redux"), require("reselect"));
	else if(typeof define === 'function' && define.amd)
		define("stateAction", ["redux-actions", "redux", "reselect"], factory);
	else if(typeof exports === 'object')
		exports["stateAction"] = factory(require("redux-actions"), require("redux"), require("reselect"));
	else
		root["stateAction"] = factory(root["reduxActions"], root["redux"], root["reselect"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_6__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition